(function () {
  angular.module("akitabox.ui.dialogs.job.cancel", [
    "akitabox.core.constants",
    "akitabox.core.services.job",
    "akitabox.core.toast",
  ]);
})();
